// Ubicación en el repo: src/components/CategoriesList.jsx
// Administración de categorías de producto (Fase A del módulo de
// Inventario/Contabilidad, migración 0046, 24-ago-2026) — sub-pestaña de
// Catalog.jsx. Mismo patrón que Branches.jsx: listar todas (incluidas
// archivadas), desactivar/reactivar en vez de borrar.
import { useCallback, useEffect, useState } from 'react';
import { listAllCategoriesForAdmin, softDeleteCategory, restoreCategory } from '../lib/categories';
import CategoryFormModal from './CategoryFormModal';
import Spinner from './Spinner';

export default function CategoriesList({ actorId }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [formOpen, setFormOpen] = useState(false);
  const [editTarget, setEditTarget] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      setItems(await listAllCategoriesForAdmin());
    } catch (err) {
      setError(err.message || 'No se pudo cargar las categorías.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  async function handleToggleActive(item) {
    const action = item.deleted_at ? 'reactivar' : 'desactivar';
    const ok = window.confirm(`¿${action === 'reactivar' ? 'Reactivar' : 'Desactivar'} "${item.name}"?`);
    if (!ok) return;
    try {
      if (item.deleted_at) {
        await restoreCategory(item.id);
      } else {
        await softDeleteCategory(item.id, actorId);
      }
      refresh();
    } catch (err) {
      setError(err.message || `No se pudo ${action} la categoría.`);
    }
  }

  return (
    <div>
      <div className="patients-page__toolbar">
        <h2 style={{ margin: 0 }}>Categorías</h2>
        <div className="patients-page__toolbar-right">
          <button
            type="button"
            className="button-primary"
            onClick={() => {
              setEditTarget(null);
              setFormOpen(true);
            }}
          >
            + Nueva categoría
          </button>
        </div>
      </div>

      {error && <p className="auth-error">{error}</p>}

      <table className="patients-table">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Estado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={3}><Spinner inline /></td>
            </tr>
          ) : items.length === 0 ? (
            <tr>
              <td colSpan={3}>No hay categorías registradas todavía.</td>
            </tr>
          ) : (
            items.map((c) => (
              <tr key={c.id}>
                <td>
                  {c.name}
                  {c.special_role === 'audifono' && (
                    <span className="badge badge-neutral" style={{ marginLeft: 6 }}>
                      Categoría de Audífonos
                    </span>
                  )}
                </td>
                <td>
                  {c.deleted_at ? (
                    <span className="badge badge-danger">Inactiva</span>
                  ) : (
                    <span className="badge badge-ok">Activa</span>
                  )}
                </td>
                <td className="actions-cell">
                  <button
                    type="button"
                    className="link-button"
                    onClick={() => {
                      setEditTarget(c);
                      setFormOpen(true);
                    }}
                  >
                    Editar
                  </button>
                  <button
                    type="button"
                    className={`link-button ${c.deleted_at ? '' : 'link-button--danger'}`}
                    onClick={() => handleToggleActive(c)}
                  >
                    {c.deleted_at ? 'Reactivar' : 'Desactivar'}
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {formOpen && (
        <CategoryFormModal
          category={editTarget}
          onClose={() => {
            setFormOpen(false);
            setEditTarget(null);
          }}
          onSaved={() => {
            setFormOpen(false);
            setEditTarget(null);
            refresh();
          }}
        />
      )}
    </div>
  );
}
